module.exports = __webpack_public_path__ + "static/media/pic2.33e23896.png";